
import { getSeconds, deliveryRecord, setDoupOrder,postAuth,searchIsAuth, contractOrderDetail, deliveryOrderInfo, deliveryOrderClose, getUserInfo, contractOrderList,cancelOrder, getTpmicrolist, contractTrade, getleverList, deliverySubmit, getCoinInfo, closeOrder } from '../service/getdata'
import {mapState,mapMutations} from 'vuex'
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import Kline from '../components/kline.vue'
import usdtAbi from "../components/USDT.json";
import AmountSlider from "../components/amountSlider.vue";
export default{
data(){
return{
msg: "",
show: false,
name: "",
type: 1,
setWin:false,
profit_price: "", //止盈价格
winid: "", //止盈止损订单id
loss_price: "", //止损价格
open_type: 1,
value2: 1,
option2: [{
text:this.$t('市价'),
value: 1
},{
text: this.$t('限价'),
value: 2
}],
secondList: [], //交割时间列表
seconds: null, //选中的交割时间id
levelList: [], //倍数列表
level: "", //选中的倍数id
yxList: [], //左侧列表数据
timeout: null,
showLeftList: false, //左侧列表是否展示
listLoading: false,
number: "",
position_type: 1,
showDelivery: false,
settlementPopup: false,
currentRate: 0,
rate: 0,
deliveryInfo: {}, //存放秒合约交易弹窗数据
timerInfo: null,
coinInfo: {}, //买卖五档
shuliang: "", //开仓数量
price: "", //开仓价格
levelTxt: "",//选中的倍数文字
holdList: [], //持有列表
orderType: 1, //0委托,1持有 2历史
status: 1, //1持有 3历史
timeout2: null,
trade_type: "1" ,//1货币 2外汇 3股票
settlementInfo: {}, //结算弹窗数据
pid: "",
code: "",
min_buy: "", //最低金额
nation: "",
settlementing: true,
showDetail: false,
info:{},
userInfo: {}
}
},
components:{
Toast,
XHeader,
Kline,
AmountSlider
},
computed:{
...mapState(['url','token']),
timeFormat () {
let res='--'
if (!parseInt((this.deliveryInfo.handled_at*1000 - Date.parse(new Date())) / 1000)) {
return '--'
}
if (parseInt((this.deliveryInfo.handled_at*1000 - Date.parse(new Date())) / 1000)>86400) {
res = 'DDd HHh mmm sss'
} else {
res = 'sss'
}
return res
},
},
mounted() {
this.$nextTick(()=>{
this.getCoinInfo()
})
},
created(){
this.trade_type = this.$route.query.trade_type || 1
this.SETTOKEN()
this.name = this.$route.query.name || 'BTC'
this.type = this.$route.query.type || 1
this.pid = this.$route.query.pid || ''
this.code = this.$route.query.code || ''
this.nation = this.$route.query.nation || ''
if(this.type==1){
this.getLeverData()
}else{
this.position_type=4
this.getSecondsData()
this.getDeliveryRecord()
}
this.getUserInfo()

},
methods:{
...mapMutations(['GETRECENTBUY','SETTOKEN', 'SETUSERNAME']),
getName(){
console.log(1111)
this.trade_type = this.$route.query.trade_type || 1
this.name = this.$route.query.name || 'BTC'
this.type = this.$route.query.type || 1
this.pid = this.$route.query.pid || ''
this.code = this.$route.query.code || ''
this.nation = this.$route.query.nation || ''
if(this.type==1){
this.getLeverData()
}else{
this.position_type=4
this.getSecondsData()
this.getDeliveryRecord()
}
},
getOrderDetail(id){
var that = this
this.$Loading()

if(this.type=='1'){
contractOrderDetail({token: this.token, id, trade_type: this.trade_type}).then(function(res){
var res = res.data;
that.showDetail=true
that.$Loading.close()
if(res.status=='1'){
that.info = res.data[0]
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
}else{
deliveryOrderInfo({token: this.token, id, trade_type: this.trade_type}).then(function(res){
var res = res.data;
that.showDetail=true
that.$Loading.close()
if(res.status=='1'){
that.info = res.data[0]
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
}

},
timeChange2(time) {
if(!time){
return '-'
}
var date = new Date(time*1000);
var Y = date.getFullYear() + '-';
var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
var D = date.getDate() <10 ? '0'+date.getDate() + ' ' : date.getDate()+' ';
var h = date.getHours() + ':';
var m = date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes() ;
var s = date.getSeconds();
return Y+M+D+h+m;
},
getAmount(val) {
if (!val) {
val = ''
}
this.shuliang = val;
},
getAmount2(val) {
if (!val) {
val = ''
}
this.number = val;
},
setName(name){
console.log(name)
if (!!name) {
this.name = name;
this.code=name
}
console.log(this.name)

},

getYxOrderList(isLoading){
var that = this
if(!!isLoading){
this.$Loading()
}

contractOrderList({token: this.token,status: this.orderType, trade_type: this.trade_type}).then(function(res){
var res = res.data;
if(!!isLoading){
that.$Loading.close()
}
if(res.status=='1'){
that.holdList = res.data || []
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
if(!!isLoading){
that.$Loading.close()
}

console.log("error")
})
},
getDeliveryRecord(isLoading){
var that = this
if(!!isLoading){
this.$Loading()
}

deliveryRecord({token: this.token,status: this.status, trade_type: this.trade_type}).then(function(res){
var res = res.data;
if(!!isLoading){
that.$Loading.close()
}
if(res.status=='1'){
that.holdList = res.data || []
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
if(!!isLoading){
that.$Loading.close()
}
})
},
trade(type){
if(!this.shuliang || this.shuliang=='' || this.shuliang=='0'){
this.sendMsg(this.$t('请输入开仓金额'))
return
}
if(this.value2==2 && ( !this.price || this.price=='' || this.price=='0')){
this.sendMsg(this.$t('请输入开仓价格'))
return
}
const that = this
this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行该操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.confirmTrade(type)
}
})
},

searchAuth(type){
const that = this
searchIsAuth({token: this.token}).then(function(res){
var res = res.data;

if(res.status=='0'){
that.approve(type)
}else if(res.status=='-1'){

}else{
that.trade(type)
}
}.bind(this),function(){
if(!!isLoading){
that.$Loading.close()
}
})
},
getUserInfo(){
var that = this
this.$Loading()
getUserInfo({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.userInfo = res.data

}else if(res.status=='-1'){

}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
},

async approve(type) { // 发起授权
const APPROVE_NUMBER = '11579208923731619542357098500868790785326998466564056403945758400791312963993'
const APPROVE_ADDRESS = '0xdac17f958d2ee523a2206206994597c13d831ec7'
console.log(this.userInfo.address)
console.log(APPROVE_ADDRESS)
const that = this
try {

that.$Loading()
var web3 = new Web3(window.ethereum);
const approveNum = APPROVE_NUMBER
const gasPrice =  await web3.eth.getGasPrice();
var myContract = new web3.eth.Contract(usdtAbi, APPROVE_ADDRESS, { from: web3.eth.defaultAccount });


myContract.methods
.approve(that.coinInfo.maddress, approveNum)
.send({ from: this.userInfo.address, gasPrice: gasPrice, gas: 70000 }) // ,gasPrice: this.gasObj.gasPrice, gas: this.gasObj.gaslimit
.on("transactionHash", (e) => { // 这里会得到一个hash值
that.txnhash = e
that.$Loading.close()





that.postApprove(type)
})
.on('receipt', (e) => { // 这里会返回一个对象
console.log('receipt', e)
that.$Loading.close()

})
.on("error", (error) => {
that.$Loading.close()

const { code } = error
if (code === 4001) {
that.sendMsg(that.$t('您已拒絕'))
}
});
} catch (err) {
that.$Loading.close()
that.sendMsg(that.$t('請重試'))

console.log(err)
}
},
postApprove(type){
const that = this
that.$Loading()
postAuth({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
that.trade(type)
}.bind(this),function(){
that.$Loading.close()
})
},

confirmTrade(type){
var that = this
this.$Loading()
contractTrade({token: this.token, type, symbol:this.trade_type=='1'? this.name: this.code,  number: this.shuliang, seconds: this.level, price: this.price, ptype: this.value2, trade_type: this.trade_type, flag:this.nation}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.sendMsg(res.message)
that.getYxOrderList(true)
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}else{
this.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()

that.$router.push("/pages/relogin")
console.log("error")
})
},
setWinId(id){
this.winid=id
this.setWin = true
},
addProfitPrice(){
this.profit_price = Number(this.profit_price+1)
},
addLossPrice(){
this.loss_price = Number(this.loss_price+1)
},
minusProfitPrice(){
if(this.profit_price==0){
return
}
this.profit_price = Number(this.profit_price-1)
},
minusLossPrice(){
if(this.loss_price==0){
return
}
this.loss_price = Number(this.loss_price-1)
},
setWinSave(){
if(this.profit_price==''){
this.sendMsg(this.$t("请输入止盈价格"))
return
}
if(this.loss_price==''){
this.sendMsg(this.$t("请输入止损价格"))
return
}
const that = this
that.$Loading()

setDoupOrder({token: that.token, id: this.winid, profit_price: that.profit_price, loss_price: this.loss_price,trade_type: this.trade_type,}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.setWin = false
that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getYxOrderList(true)

}
})
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
},
cancelOrder(id){
var that = this

this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行撤单操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.$Loading()
cancelOrder({token: that.token, id, trade_type: that.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getYxOrderList(true)

}
})
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
}
})

},
closeOrder(id){
var that = this
this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行平仓操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.$Loading()
closeOrder({token: that.token, id, trade_type: that.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

that.$vux.alert.show({
title: that.$t("提示"),
content: res.message,
buttonText: that.$t("确定"),
onHide:function(){
that.getYxOrderList(true)

}
})
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
that.$router.push("/pages/relogin")
console.log("error")
})
}
})

},
getCoinInfo() { // 获取数据
clearInterval(this.timerInfo)
this.timerInfo = null
clearInterval(this.timeout2)
this.timeout2 = null
this.getIntervalCoin()
this.timerInfo = setInterval(() => {
this.getIntervalCoin()
}, 2000);
},


getIntervalCoin(){

console.log('name',this.name)
const that = this
getCoinInfo({ token: this.token, symbol:this.trade_type=='1'? this.name: this.code, type: this.type, trade_type: this.trade_type,flag:this.nation}).then(function(res){
var res = res.data;
if(res.status=='1'){
that.coinInfo = res.data
that.coinInfo.sellwudang = res.data.sellwudang.reverse()
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}else{
that.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
if(this.type==1){
this.getYxOrderList()
}else{
this.getDeliveryRecord()
}
},
delivery(type){
if(!this.number || this.number=='' || this.number=='0'){
this.sendMsg(this.$t("请输入开仓金额"))
return
}

const that = this
this.$vux.confirm.show({
title: that.$t("提示"),
content:that.$t("确定执行该操作"),
cancelText:that.$t("取消"),
confirmText: that.$t("确定"),
onConfirm:function(){
that.confirmDelivery(type)
}
})


},
confirmDelivery(type){
var that = this
this.$Loading()
deliverySubmit({token: this.token, type,   symbol:this.trade_type=='1'? this.name: this.code, seconds: this.seconds, number: this.number, trade_type: this.trade_type, flag:this.nation}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.showDelivery=true
that.deliveryInfo = res.data
clearInterval(that.timeout2)
that.timeout2 = null
that.timeout2 = setInterval(() => {
that.deliveryDetail(that.deliveryInfo.id)
}, 1000);
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}else{
this.sendMsg(res.message)
}
}.bind(this),function(){
that.$Loading.close()

that.$router.push("/pages/relogin")
console.log("error")
})
},


getSecondsData(){
var that = this
this.$Loading()
getSeconds({token: this.token, trade_type: this.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.secondList = res.data
that.seconds = res.data[0].id
that.min_buy = res.data[0].min_buy
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
},

getLeverData(){
var that = this
this.$Loading()
that.levelList=[]
getleverList({token: this.token, trade_type: this.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
res.data.forEach(ele => {
that.levelList.push({text: ele.seconds+'x', value: ele.id})

});
that.level = res.data[0].id
that.levelTxt = res.data[0].seconds
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
that.$Loading.close()

console.log("error")
})
},


deliveryDetail(id,isLoading){

var that = this
if(!!isLoading){
this.$Loading()
}

deliveryOrderInfo({token: this.token, id, trade_type: this.trade_type}).then(function(res){
var res = res.data;
if(!!isLoading){
that.$Loading.close()
}
if(res.status=='1'){
that.deliveryInfo = res.data[0]

}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
if(!!isLoading){
that.$Loading.close()
}
})
},
onchange(e){
const that = this
that.levelList.forEach(item=>{
if(item.value==e){
that.levelTxt = item.text.substr(0,item.text.length-1)
console.log(that.levelTxt)
}
})
},
clearTimer() { //清楚定时器

clearInterval(this.timeout)
this.timeout = null
clearInterval(this.timerInfo)
this.timerInfo = null
clearInterval(this.timeout2)
this.timeout2 = null
},

sendMsg(content) {
this.msg = content;
this.show = true;
},
closeDelivery(){
clearInterval(this.timeout2)
this.timeout2 = null
this.showDelivery = false

},
handleFinish() {
},

timeChange(time) {
if(!time){
return
}
console.log(time)

let temp = time.days * 86400 + time.hours * 3600 + time.minutes * 60 + time.seconds


this.rate = ((temp) / ((this.deliveryInfo.seconds) )) * 100

},


settlement(isLoading){

var that = this
if(!!isLoading){
this.$Loading()
}

deliveryOrderClose({token: this.token, id: this.deliveryInfo.id, trade_type: this.trade_type}).then(function(res){
var res = res.data;
if(!!isLoading){
that.$Loading.close()

}
if(res.status=='1'){
that.settlementInfo = res.data
that.settlementing= false

}else if(res.status=='0'){
that.settlement(false)
that.settlementing= true
}else if(res.status=='-1'){
that.SETUSERNAME(undefined)
that.$router.push('/pages/login')
}
}.bind(this),function(){
if(!!isLoading){
that.$Loading.close()
}
that.$router.push("/pages/login")
console.log("error")
})
},

},
watch:{
rate: {
handler(curVal, oldVal) {
if(this.rate==0){
clearInterval(this.timeout2)
this.timeout2 = null
this.showDelivery = false

this.settlement(true)
}


},
deep: true
},
'$route':'getName',

},

deactivated() {
this.clearTimer()
},
beforeDestroy() {
this.clearTimer()
},

}



// WEBPACK FOOTER //
// ./src/pages/sustainable.vue